<template>
    <label class="opui-form-label-top">{{ $e('Wait for') }}</label>

    <div class="opui-row">
        <div class="opui-col-2">
            <input type="number" class="opui-form-control" v-model="item.settings.value" @input="updateItem">
        </div>

        <div class="opui-col-3">
            <select class="opui-form-control" v-model="item.settings.unit" @change="updateItem">
                <option value="i">{{ $e('Minute(s)') }}</option>
                <option value="h">{{ $e('Hour(s)') }}</option>
                <option value="d">{{ $e('Day(s)') }}</option>
                <option value="w">{{ $e('Week(s)') }}</option>
                <option value="m">{{ $e('Month(s)') }}</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item:     { type: Object, required: true },
        workflow: { type: Object, required: true },
    },
    mounted() {
        this.setTitleAndDescription()
    },
    methods: {
        updateItem() {
            this.setTitleAndDescription()
        },

        setTitleAndDescription() {
            this.item.title = 'Delay'

            // Find the unit name
            let unitName = 'minute(s)'
            if (this.item.settings.unit === 'h') unitName = 'hour(s)';
            if (this.item.settings.unit === 'd') unitName = 'day(s)';
            if (this.item.settings.unit === 'w') unitName = 'week(s)';
            if (this.item.settings.unit === 'm') unitName = 'month(s)';

            this.item.description = 'Wait for ' + this.item.settings.value + ' ' + unitName
        }
    }
}
</script>
